module.exports = {"TXTCLI_Invalid_date":{"id":"TXTCLI_Invalid_date","defaultMessage":"Ugyldig dato","track":"Invalid date"}}